import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useMessages } from '@/api';
import type { PlayerMessage } from '@/domain/messages';
import { useTranslations } from '@/i18n/TranslationsProvider';
import { MessagesPanel } from '@/ui/profile';

export const Route = createFileRoute('/profile/messages/')({
  component: ProfileMessagesPage,
});

export function ProfileMessagesPage() {
  const { t, i18n } = useTranslation();
  const { selectedLanguage } = useTranslations();
  const navigate = useNavigate();
  const isTranslationReady =
    selectedLanguage === 'en' || i18n.hasResourceBundle(selectedLanguage, 'translation');
  const label = (key: string, fallback: string) =>
    isTranslationReady ? t(key, { defaultValue: fallback }) : fallback;

  const messages = useMessages(true);

  const onSelectMessage = (message: PlayerMessage) => {
    void navigate({
      to: '/profile/messages/$messageId',
      params: { messageId: message.Id },
    });
  };

  return (
    <div className="flex flex-col gap-4 lg:gap-6">
      <header className="flex flex-col gap-1 lg:gap-2">
        <h1 className="text-[18px] font-bold text-text-primary lg:text-[22px]">
          {label('Messages', 'Messages')}
        </h1>
        <p className="text-[13px] text-text-secondary">
          {label(
            'Inbox from support and system notices',
            'Inbox from support and system notices',
          )}
        </p>
      </header>
      <MessagesPanel messages={messages} onSelectMessage={onSelectMessage} />
    </div>
  );
}
